import { render, staticRenderFns } from "./share-form.vue?vue&type=template&id=7087e7a2"
import script from "./share-form.vue?vue&type=script&lang=js"
export * from "./share-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports